import React, { createContext, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useOktaAuth } from '@okta/okta-react'
import { useAuthState } from '../../hooks'
import { setToken } from '../../service'

const AuthContext = createContext({
  loading: true,
  token: null
})

export const useAuthToken = () => {
  return useContext(AuthContext)
}

function AuthProvider ({ children }) {
  const auth = useOktaAuth()
  const authState = useAuthState(auth.authState)

  const providerValue = useMemo(() => {
    if (authState.accessToken?.accessToken) {
      setToken(authState.accessToken?.accessToken)
    }
    return ({
      loading: !authState.accessToken?.accessToken,
      token: authState.accessToken?.accessToken || null
    })
  }, [authState.accessToken?.accessToken])

  return (
    <AuthContext.Provider value={providerValue}>
      {children}
    </AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.node
}

export default AuthProvider
